<div class="lm-wrap">
  <h3 class="lm-heading">{{ heading }}</h3>

  <div class="light-mixer">
    <div class="lm-head">
      <!-- The swatch itself is the colour picker (matches the color-converter widget). -->
      <input class="lm-swatch" type="color" [value]="baseHex"
             (input)="onPicker( $any( $event.target ).value )" aria-label="Pick a color">
      <div class="lm-input-wrap">
        <label class="lm-label" for="lm-hex">Pick a Color</label>
        <input id="lm-hex" class="lm-text" type="text" autocomplete="off" spellcheck="false"
               maxlength="7" inputmode="latin" [value]="text"
               (input)="onText( $any( $event.target ).value )" (keydown)="onKey( $event )"
               aria-label="Hex color code">
      </div>
    </div>

    <p class="lm-caption">Light Waves Simulation</p>
    <div class="lm-stage">
      <canvas #waves class="lm-waves"></canvas>
      <!-- Neutral focus overlay marking the centre, where the three waves overlap. -->
      <div class="lm-focus" aria-hidden="true">
        <span class="lm-fade lm-fade-left"></span>
        <span class="lm-fade lm-fade-right"></span>
        <span class="lm-focus-frame"></span>
        <span class="lm-focus-line"></span>
        <span class="lm-focus-caret lm-focus-caret-top"></span>
      </div>
    </div>

    <div class="lm-legend">
      <span class="lm-chip"><span class="lm-dot lm-dot-r"></span><span>Red {{ wavelengths.r }} nm &middot; <span class="lm-pow">{{ pct( r ) }}%</span></span></span>
      <span class="lm-chip"><span class="lm-dot lm-dot-g"></span><span>Green {{ wavelengths.g }} nm &middot; <span class="lm-pow">{{ pct( g ) }}%</span></span></span>
      <span class="lm-chip"><span class="lm-dot lm-dot-b"></span><span>Blue {{ wavelengths.b }} nm &middot; <span class="lm-pow">{{ pct( b ) }}%</span></span></span>
    </div>
  </div>
</div>
